export const BUDGET_DATA_UPDATED_EVENT = 'budget_app_data_updated' as const;
export const VERSIONING_UPDATED_EVENT = 'VERSIONING_UPDATED' as const;
export const OFFLINE_QUEUE_MUTATION_DROPPED_EVENT = 'offline_queue_mutation_dropped' as const;
